module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Parcel Number Consumption")])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error",
      "value": _vm.parcelNumberContainerConsumptionError
    }
  }, [_vm._v(_vm._s(_vm.parcelNumberContainerConsumptionError))]), _vm._v(" "), _c('v-card-text', [_c('bar-chart', {
    attrs: {
      "chart-data": _vm.parcelNumberContainerConsumptionBarChartData.datacollection,
      "scalesdisplay": false,
      "width": 350,
      "height": 200,
      "options": _vm.parcelNumberContainerConsumptionBarChartDataOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Returns Quantity")])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "type": "error",
      "value": _vm.returnQuantityBarChartDataError
    }
  }, [_vm._v(_vm._s(_vm.returnQuantityBarChartDataError))]), _vm._v(" "), _c('v-card-text', [_c('bar-chart', {
    attrs: {
      "chart-data": _vm.returnQuantityBarChartData.datacollection,
      "scalesdisplay": false,
      "width": 350,
      "height": 200,
      "options": _vm.returnQuantityBarChartDataOptions
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_vm._v("\n            Version: "), _c('b', [_vm._v(_vm._s(_vm.version))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-card', [_vm._v("\n            Build-Time: "), _c('b', [_vm._v(_vm._s(_vm.buildTime))])])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-1bd07fba"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Dashboard.vue
// module id = 923
// module chunks = 1